import { Navigate, Route, Routes } from 'react-router';
import { browserHistory, ReactRouter } from './history';
import { useIsEmberRoute } from './hooks/use-is-ember-route';
import { NotFound } from './routes/not-found';
import { ClientPortalRoute } from './routes/client-portal';
import { InvoicesIndexRoute } from './routes/invoices/index';
import { InvoicePayRoute } from './routes/invoices/pay';
import { InvoiceNotFound } from './routes/invoices/not-found';
import { QuotesSigningErrorRoute } from './routes/quotes/signing/error';
import { QuotesSigningSignatureFailedRoute } from './routes/quotes/signing/signature-failed';
import { QuotesSigningNotAvailableRoute } from './routes/quotes/signing/not-available';
import { QuotesSigningRoute } from './routes/quotes/signing';
import { QuotesIndexRoute } from './routes/quotes/index';
import { CreditNotesRoute } from './routes/credit-notes';
import { PaymentLinksRoute } from './routes/payment-links';
import { MollieActivationRoute } from './routes/mollie-activation';
import { MandatesRoute } from './routes/mandates';
import { MandatesSuccessRoute } from './routes/mandates/success';
import { MandatesInvitationRoute } from './routes/mandates-invitation';
import { MandatesInvitationSuccessRoute } from './routes/mandates-invitation/success';

function CheckIfEmberHasRoute(): React.ReactNode {
  const isEmberRoute = useIsEmberRoute();
  return isEmberRoute ? null : <Navigate replace to="/404" />;
}

export function Router({ path }: { path: string }): React.ReactNode {
  return (
    // @ts-expect-error react-router's History type has extra methods
    <ReactRouter history={browserHistory} key={path}>
      <Routes>
        <Route element={<ClientPortalRoute />} path="/clients/:id" />
        <Route path="/invoices/:id">
          <Route element={<InvoicesIndexRoute />} index />
          <Route element={<InvoicePayRoute />} path="pay" />
          <Route element={<InvoiceNotFound />} path="not-found" />
        </Route>
        <Route path="/quotes/:id">
          <Route element={<QuotesIndexRoute />} index />
          <Route path="signing/:clientId">
            <Route element={<QuotesSigningRoute />} index />
            <Route element={<QuotesSigningErrorRoute />} path="error" />
            <Route element={<QuotesSigningSignatureFailedRoute />} path="signature-failed" />
            <Route element={<QuotesSigningNotAvailableRoute />} path="not-available" />
          </Route>
        </Route>
        <Route element={<CreditNotesRoute />} path="/credit-notes/:id" />
        <Route element={<PaymentLinksRoute />} path="/payment-links/:id" />
        <Route element={<MollieActivationRoute />} path="/mollie-activation" />
        <Route path="/mandates/:id">
          <Route element={<MandatesRoute />} index />
          <Route element={<MandatesSuccessRoute />} path="success" />
        </Route>
        <Route path="/mandates-invitation/:id">
          <Route element={<MandatesInvitationRoute />} index />
          <Route element={<MandatesInvitationSuccessRoute />} path="success" />
        </Route>
        <Route element={<NotFound />} path="/404" />
        <Route element={<NotFound />} path="/error" />
        <Route element={<CheckIfEmberHasRoute />} path="*" />
      </Routes>
    </ReactRouter>
  );
}
